import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ApplicationForm from './components/ApplicationForm';

export default function ApplyPage() {
  return (
    <div className="min-h-screen bg-[#F9F9F7]" style={{ fontFamily: "'Google Sans Flex', sans-serif" }}>
      <Navbar />
      <main>
        {/* Hero */}
        <section
          className="pt-36 pb-20 px-5 md:px-[75px]"
          style={{ background: 'linear-gradient(135deg, #1a3870 0%, #061e45 100%)' }}
        >
          <div className="max-w-[1400px] mx-auto">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 mb-6" aria-label="Breadcrumb">
              <a
                href="/"
                className="text-white/40 text-[11px] uppercase tracking-[0.18em] hover:text-white/70 transition-colors duration-200 cursor-pointer"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                Home
              </a>
              <span className="text-white/25 text-[11px]">/</span>
              <span
                className="text-[#d3b366] text-[11px] uppercase tracking-[0.18em]"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                Apply
              </span>
            </nav>
            <p
              className="text-[10px] uppercase tracking-[0.28em] font-medium mb-5"
              style={{ fontFamily: "'Google Sans Flex', sans-serif", color: 'rgba(211,179,102,0.8)' }}
            >
              Merchant Processing Application
            </p>
            <h1
              className="text-4xl md:text-5xl lg:text-[58px] font-light leading-[1.1] mb-6 text-white"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Let's Get You Set Up.
            </h1>
            <p
              className="text-[15px] leading-relaxed max-w-2xl"
              style={{ color: 'rgba(255,255,255,0.55)' }}
            >
              Complete this application to begin the underwriting process. The form takes approximately 10 minutes.
              All information is encrypted in transit and at rest.
            </p>
            <div className="flex flex-wrap gap-8 mt-10">
              {[
                { icon: 'ri-time-line', text: '~10 minutes to complete' },
                { icon: 'ri-shield-check-line', text: 'SSL-encrypted & secure' },
                { icon: 'ri-customer-service-2-line', text: 'Response within 1–2 business days' },
              ].map(item => (
                <div key={item.text} className="flex items-center gap-2">
                  <i className={`${item.icon} text-[#d3b366]`} />
                  <span className="text-white/60 text-[13px]">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Form */}
        <section className="py-20 px-5 md:px-[75px]">
          <div className="max-w-[900px] mx-auto">
            <ApplicationForm />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
